import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeUp, Overline } from "./Reveal";
import { GROUPS } from "@/lib/products";

export default function ProductGroups() {
  return (
    <section id="product-groups" data-testid="product-groups-section" className="bg-white py-20 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <FadeUp className="mx-auto max-w-3xl text-center">
          <Overline>Product Portfolio</Overline>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-[1.08] tracking-tight text-navy md:text-5xl">
            Our Product Groups
          </h2>
          <p className="mt-5 text-base leading-relaxed text-navy/70 md:text-lg">
            From whole spices to ready-to-eat meals — eight export-ready
            product groups, one reliable partner.
          </p>
        </FadeUp>

        <div data-testid="product-groups-grid" className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {GROUPS.map((g, i) => (
            <FadeUp key={g.slug} delay={Math.min(i, 8) * 0.05}>
              <Link
                to={`/products/${g.slug}`}
                data-testid={`group-card-${g.slug}`}
                className="group flex h-full flex-col overflow-hidden rounded-2xl border border-navy/10 bg-white transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-navy/10"
              >
                <div className="overflow-hidden">
                  <img
                    src={g.image}
                    alt={`${g.name} — RBL EXIM export product group`}
                    loading="lazy"
                    className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-[1.05]"
                  />
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <h3 className="font-display text-lg font-semibold tracking-tight text-navy">
                    {g.name}
                  </h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-navy/60">
                    {g.description}
                  </p>
                  <p className="mt-5 flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.14em] text-gold-dark">
                    Explore Products
                    <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
                  </p>
                </div>
              </Link>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
